import { render, staticRenderFns } from "./GenericTagSearchDropdown.vue?vue&type=template&id=388d5353"
import script from "./GenericTagSearchDropdown.vue?vue&type=script&lang=js"
export * from "./GenericTagSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports